export default __webpack_public_path__ + "static/media/isecure.400d0f6b.jpg";